var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTracker128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8478 16.5029C70.0712 16.5029 63.2214 20.4145 59.2129 26.3506C56.535 24.9954 53.4981 24.2309 50.28 24.2309C39.4552 24.2309 30.68 32.8808 30.68 43.5509C30.68 43.7451 30.6829 43.9385 30.6887 44.1313C29.7563 43.9162 28.7829 43.8029 27.7826 43.8029C20.723 43.8029 15 49.4441 15 56.4029C15 63.3617 20.723 69.0029 27.7826 69.0029C27.8111 69.0029 27.8395 69.0028 27.8679 69.0027L98.087 69.0029L98.0866 68.9685C106.415 68.4283 113 61.5987 113 53.2529C113 45.6288 107.504 39.2699 100.205 37.8154C99.8108 25.9793 89.952 16.5029 77.8478 16.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.681 97.2918C78.7145 97.2934 74.3356 97.3068 73.8195 97.2916C66.0738 97.0651 60.5 88.1905 60.5 77.6586C60.5 61.672 68.723 48.3271 76.4865 45.1971C77.5262 44.7423 78.6004 44.5029 79.6835 44.5029L79.75 44.504L79.8165 44.5029C80.8996 44.5029 81.9738 44.7423 83.0136 45.1977C90.777 48.3271 99 61.672 99 77.6586C99 88.1905 93.4262 97.0651 85.6805 97.2916C85.1644 97.3068 80.7855 97.2934 79.819 97.2918H79.681Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1064 73.4526V112.17",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1068 90.9634L72.2642 82.5161",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTracker128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTracker128.d9c4c85fc15b4c4c418a407c7cce2d02.svg";
export { ForwardRef as ReactComponent };